import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import _ from "lodash"
import CRUD from "../../../Shared/enums/CRUD";
import {Avatar} from "antd";
import getAvatar from "../../../../helpers/getAvatar";
import {BsPersonFill} from "react-icons/bs";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";

export const renderEventCheckinItem = ({translate: t, isLg, lookupParams = {}, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const { user, event_location, checkin_time, status } = item ?? {}

    return (
        <div className="flex gap-3 rounded-lg custom-item-render render-border-center hover:shadow relative">
            <Avatar
                size={100}
                className="flex flex-center background-200 rounded-l-lg rounded-r-0 cursor-pointer"
                src={getAvatar(user)}
                icon={<BsPersonFill size={60} className="text-color-500"/>}
                onClick={() => {handleAction(CRUD.READ, item)}}
            />
            <div className="py-2 flex flex-col flex-1 gap-1">
                <div
                    onClick={() => {handleAction(CRUD.READ, item)}}
                    className="mr-3 font-bold text-base text-color-000 hover:text-primary leading-tight cursor-pointer">
                    {user?.patron_saint_name ? `${user?.patron_saint_name} ` : ''}
                    {user?.name}
                </div>
                <div className="flex flex-col flex-1">
                    <ItemInformation label="locations" value={event_location?.name} className="text-xs italic"/>
                    <ItemInformation label="time" value={formatSimplifyDate(checkin_time, 'fullTime')} className="text-xs italic"/>
                    <ItemInformation label="status" value={status === 1 ? t('success') : t('unsuccessful')} className="text-xs italic"/>
                </div>
                <div className="absolute bottom-10 right-10">
                    <div
                        onClick={() => {handleAction(CRUD.READ, item)}}
                        className="text-xs text-color-500 hover:text-color-100 italic tracking-wide cursor-pointer">
                        {`${t('view detail')}...`}
                    </div>
                </div>
            </div>
            {renderIf(
                _.isFunction(renderContextMenu),
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}

